import React, { useState, useEffect } from 'react';
import ListTable from '../../Common Components/List_Table';
import NormalListTable from '../../Common Components/Normal_List_Table';
import TaskServiceController from '../../../Controllers/TaskService';
import CustomToaster, { notify } from "../../Common Components/Custom_Toaster";
import ConfirmPopup from "../../Common Components/Confirm_Popup";
import Custom_InfoBar from '../../Common Components/Custom_InfoBar';

const TaskList = ({ onHandleClick, editTaskData, toolTipData }) => {
  const [tasksRows, setTasksRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [confirmPopupData, setConfirmPopupData] = useState({
    dataId: null,
    template: "",
    popupType: "",
    name: "",
  });
  const [name, setName] = useState("");
  const tableHeading = [
    "S.No",
    "Task Name",
    "Task Category", "Date", "Create/Modified By", "Publish", ""
  ];
  function createData(
    sNo,
    taskName, parameter, date, created, publish, menu
  ) {
    return {
      sNo,
      taskName, parameter, date, created, publish, menu
    };
  }

  const taskCont = new TaskServiceController();
  var Spinner = require('react-spinkit');
  const [shouldReload, setShouldReload] = useState(false);

  const getJsonData = async () => {
    const body = await taskCont.getTasksList();
    setTasksRows(
      Array.isArray(body) && body.length > 0
        ? body.map((item, index) => ({
          sNo: (index + 1).toString().padStart(2, '0'),
          taskName: item.taskName,
          taskCtg: item.taskCategory ?? '-',
          date: item.date,
          create: item.createOrModifiedBy ?? '-',
          publish: item.isPublished ? "Published" : "Publish",
          preview: "",
          menu: "",
          uniqueId: item.id,
          item: item,
        }))
        : []
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsProcessing(true);
      await getJsonData();
      setIsProcessing(false);
      setShouldReload(false);
    }
    fetchData();
  }, [shouldReload]);

  const publishTask = (id) => {
    setIsLoading(true);
    setTimeout(async () => {
      const body = await taskCont.publishTasks(id);
      setIsLoading(false);
      closePopupOnFinishingApiCall();
      body["Success"]
        ? notify(`${name} has been successfully published`, true)
        : notify(
          "There was an error while performing publishing operation. Please try again later...",
          false
        );
    }, 1000);
  }

  const deleteTask = (id) => {
    setIsLoading(true);
    setTimeout(async () => {
      const body = await taskCont.deleteTasks(id);
      setIsLoading(false);
      closePopupOnFinishingApiCall();
      body["Success"]
        ? notify(`${name} has been successfully deleted`, true)
        : notify(
          "There was an error while performing deletion operation. Please try again later...",
          false
        );
    }, 1000);
  }

  const openPopup = (type, id, template, name) => {
    setIsPopupOpen(!isPopupOpen);
    setConfirmPopupData({
      dataId: id,
      template: template,
      popupType: type,
      name: name,
    });
    setName(name);
  };
  const closePopupOnFinishingApiCall = () => {
    setIsPopupOpen(false);
    setShouldReload(true);
  };
  const editTask = (id, requestBody) => {
    editTaskData(id, requestBody);
  }
  const [taskSearchText, setTaskSearchText] = useState('');
  const filteredTasks = tasksRows.filter(task => task.taskName.toLowerCase().includes(taskSearchText.toLowerCase()));
  const handleTaskSearch = (event) => {
    setTaskSearchText(event.target.value)
  }

  const handleTaskSearchClear = () => {
    setTaskSearchText('');
  }

  const [isInfoBarVisible, setIsInfoBarVisible] = useState(true);
  const handleHideInfoBar = () => {
    setIsInfoBarVisible(!isInfoBarVisible);
  }
  
  return (
    <>
      <ListTable handleListClick={onHandleClick} drag={true} template={true} workflow={false} event={false} task={true} searchText={taskSearchText} handleSearch={handleTaskSearch} handleSearchClear={handleTaskSearchClear} />
      {
        isProcessing ?
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80%' }}>
              <Spinner name="ball-spin-fade-loader" color="#02acf6" />
            </div>
          </> :
          <>
            {/* <Custom_InfoBar toolTipData={toolTipData}/> */}

            <NormalListTable row={filteredTasks} heading={tableHeading} task={true} openPopup={openPopup} editClick={editTask} />
          </>
      }

      <ConfirmPopup
        openConfirmationPopup={isPopupOpen}
        onClose={openPopup}
        handleDeleteTemplate={deleteTask}
        handlePublishTemplate={publishTask}
        isLoading={isLoading}
        popupData={confirmPopupData}
      />
      <CustomToaster />
    </>

  )
}

export default TaskList